import React from 'react'
import RadioGroup from '../../elements/form/RadioGroup'
import ModalActionButton from '../../elements/ModalActionButton'
import { useDispatch } from 'react-redux'
import { updateStudent } from '../../../store/actions/studentsActions'

const AssignStudentStudyType = ({student, close}) => {
    const [typeSelected, setTypeSelected] = React.useState(student?.studyType || '')
    const studyTypeOptions = [
        {
            label: "Sciences",
            value: "SCIENCES"
        },
        {
            label: 'Arts',
            value: 'ARTS'
        }
    ]

    const dispatch = useDispatch()

    const pushUpdate = () => {
        if(!typeSelected || typeSelected === '') {
            return
        }

        dispatch(updateStudent(student._id, {studyType: typeSelected}))
    }
    return (
        <div className='w-full'>
            <p className='text-sm text-gray-700 mb-4'>Set the study type for this student. This will determine the subjects and curriculum that will be applicable to this student.</p>
            <RadioGroup 
                items={studyTypeOptions} 
                inline={true}
                preSelectedIndex={studyTypeOptions.findIndex(item => item.value === typeSelected)}
                inputLabel={'Study Type'}
                requiredField={true}
                returnSelected={(value) => {setTypeSelected(value.value)}} 
                hasError={false}
                titleField='label'
            />
            <div className="mt-4 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Update Study Type`}
                    buttonAction={()=>{pushUpdate()}} 
                    processing={false}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={close}
                >
                    Cancel
                </button>
            
            </div>
        </div>
    ) 
}

export default AssignStudentStudyType